import React, { useEffect } from 'react';
import '../styles/term-of-service.css';
import { useSettings } from '../context/SettingsContext';

const TermOfServicePage = () => {
    const { termOfService } = useSettings();

    useEffect(() => {
        document.title = 'Iampesmobile - Điều khoản dịch vụ';
    }, []);

    return (
        <div className="terms-container">
            <h1>Điều Khoản Dịch Vụ</h1>
            <div className="terms-list">
                {termOfService.map(term => (
                    <div key={term.id} className="term-item">
                        <h2 className="term-title">{term.title}</h2>
                        <p className="term-content">{term.content}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TermOfServicePage;
